import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M1.17 10.144c-.19.2-.19.51 0 .71l6 6c.2.2.51.2.71 0s.2-.51 0-.71l-5.15-5.15h15.79c.28 0 .5-.23.5-.5s-.22-.5-.5-.5H2.73l5.15-5.14c.2-.2.2-.51 0-.71s-.51-.2-.71 0l-6 6z',
  ],
  height: 20,
  width: 20,
});
